import * as XLSX from 'xlsx';
import { PurposeEnum } from '../../enums/purpose-enum';
import { Directive, ElementRef, EventEmitter, Input, numberAttribute, Output, ViewChild } from '@angular/core';
import { RefTypeEnum } from '../../enums/ref-type-enum';
import { StorageService } from '../../../Common/services/storage.service';
import { ProjectService } from '../../services/project.service';
import { ProjectFilesVm } from '../../models/project-vm';
import { ToastrService } from 'ngx-toastr';

@Directive()
export class BaseFileHandler<TBLOB extends Blob, UFile extends File> {

  @Input() refType: RefTypeEnum = RefTypeEnum.None;
  @Input() purpose: PurposeEnum = PurposeEnum.None;
  @Input() selectedFile?: ProjectFilesVm | null = null;
  @Input() disableAfterReview: boolean = false;
  @Input() disableAll: boolean = false;
  @Output() emitValueChanged: EventEmitter<{}> = new EventEmitter<{}>();
  
  fileName: string = '';
  isFileUploaded: boolean = false;

  maxSize = 5 * 1024 * 1024; // 5 MB

  downloadBlob: Blob | null = null;
  downloadLink: string = 'FileName.xlsx';
  fileContent: Uint8Array | null = null;
  totalCount: string = "";
  displayTotalCount: string = "";
  fileInput: ElementRef | undefined;
  columnsForValidation: any[] = [];

  contentType = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet';

  constructor(protected projectService: ProjectService,
    protected storageService: StorageService,
    protected toastr: ToastrService
  ) {
  }

  setFileInput(fileInput: ElementRef | undefined): void {
    this.fileInput = fileInput;
  }

  setColumnsForValidation(colmns: any[]): void {
    this.columnsForValidation = colmns;
  }

  setDownLoadFileName(excelFileName: any): void {
    this.downloadLink = excelFileName + ".xlsx";
  }

  base64ToBlob(base64: string, contentType: string): Blob {
    const byteCharacters = atob(base64);
    const byteLength = byteCharacters.length;
    const byteArray = new Uint8Array(byteLength);

    for (let i = 0; i < byteLength; i++) {
      byteArray[i] = byteCharacters.charCodeAt(i);
    }

    return new Blob([byteArray], { type: contentType });
  }

  downloadFile(blob: TBLOB): void {
    if (blob) {
      const a = document.createElement('a');
      const objectUrl = URL.createObjectURL(blob);
      a.href = objectUrl;
      a.download = this.downloadLink;
      a.click();
      URL.revokeObjectURL(objectUrl);
    } else {
      alert('Download link or blob is not set.');
    }
  }


  downloadAllTypeFiles(blob: TBLOB, fileName:string): void {
    if (blob) {
      const a = document.createElement('a');
      const objectUrl = URL.createObjectURL(blob);
      a.href = objectUrl;
      a.download = fileName;
      a.click();
      URL.revokeObjectURL(objectUrl);
    } else {
      alert('Download link or blob is not set.');
    }
  } 



  async getRowCountFromBlob(blob: Blob): Promise<string> {
    //const data = new Uint8Array(blob);
    const arrayBuffer = await blob.arrayBuffer();
    const data = new Uint8Array(arrayBuffer);
    const workbook = XLSX.read(data, { type: 'array' });
    const worksheet = workbook.Sheets[workbook.SheetNames[0]];
    const headers = this.getHeaders(worksheet);
    this.totalCount = (this.getRowCount(worksheet) - 1).toString();

    return this.totalCount;
  }

  // async validateExcelFile(file: UFile): Promise<boolean> {
  //     return new Promise((resolve, reject) => {
  //       const reader = new FileReader();
  //       reader.onload = (e: any) => {
  //         const data = new Uint8Array(e.target.result);
  //         const workbook = XLSX.read(data, { type: 'array' });
  //         const worksheet = workbook.Sheets[workbook.SheetNames[0]];
  //         const headers = this.getHeaders(worksheet);
  //         //if (headers.includes('StoreId') && headers.includes('StoreName')) {
  //         if(this.isFileContainsValidColumns(headers, this.columnsForValidation)){
  //           resolve(true);

  //           const arrayBuffer = e.target.result;
  //           this.fileContent = new Uint8Array(arrayBuffer);

  //           this.totalCount = (this.getRowCount(worksheet) - 1).toString();
  //           // totoal rowcount - 1 because need to exclude headers from the row
  //           //this.totalCount = "(" + (this.getRowCount(worksheet) - 1 ).toString() + ")";
  //           this.isFileUploaded = true;

  //           // this.selectedFile = {
  //           //   ...this.selectedFile,
  //           //   projectFileID:0,
  //           //   fileName: file.name,
  //           //   purpose: this.purpose,
  //           //   byteArray:  new Uint8Array(arrayBuffer),
  //           //   type: this.refType,
  //           //   refID: 0,
  //           //   createdBy: this.storageService.getItem<any>('UserInfo').userID,
  //           //   filePath: "",
  //           //   createdDate: new Date()
  //           // }

  //           let projFIleID = 0;
  //           let refId = 0;
  //           let fileArray: string = "";

  //           if(this.selectedFile == null)
  //           {
  //             this.selectedFile = new ProjectFilesVm();
  //           }

  //           if(this.selectedFile !=null
  //             && this.selectedFile != undefined
  //           )
  //           {
  //             projFIleID = this.selectedFile!.projectFileID!;
  //             refId = this.selectedFile!.refID! | 0;
  //             fileArray = btoa(String.fromCharCode.apply(null, Array.from(data)));
  //           }

  //           this.selectedFile = {
  //             projectFileID: projFIleID,
  //             fileName: file.name,
  //             purpose: this.purpose,
  //             //byteArray:  new Uint8Array(arrayBuffer),
  //             type: this.refType,
  //             refID: refId,
  //             createdBy: this.storageService.getItem<any>('UserInfo').userID,
  //             filePath: file.name,
  //             createdDate: new Date(),
  //             fileIndex: -1,
  //             fileSent: false,
  //             base64Bytes: fileArray,
  //             rowsTotalCount: parseInt(this.totalCount)
  //             //file: file
  //           }

  //           this.emitValueChanged.emit({purpose:this.purpose, selFile: this.selectedFile});

  //         } else {
  //           resolve(false);
  //           this.onDelete();
  //           this.toastr.error("Not a valid " + this.purpose + " file. Please try again.");
  //         }
  //       };
  //       reader.onerror = () => reject(false);
  //       reader.readAsArrayBuffer(file);
  //     });
  //   }


  protected async readFileAsBase64(file: File): Promise<string> {
    return new Promise((resolve, reject) => {
      const reader = new FileReader();

      reader.onload = () => {
        const result = reader.result as string;
        resolve(result.split(',')[1]);
      };

      reader.onerror = error => {
        reject(error);
      };

      reader.readAsDataURL(file);
    });
  }

  async validateExcelFile1(file: UFile): Promise<boolean> {
    return new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.onload = async (e: any) => {
        const data = new Uint8Array(e.target.result);
        const workbook = XLSX.read(data, { type: 'array' });
        const worksheet = workbook.Sheets[workbook.SheetNames[0]];
        const headers = this.getHeaders(worksheet);
        
        if (this.isFileContainsValidColumns(headers, this.columnsForValidation)) {
          //resolve(true);

          const arrayBuffer = e.target.result;
          this.fileContent = new Uint8Array(arrayBuffer);

          this.totalCount = (this.getRowCount(worksheet) - 1).toString();
          this.isFileUploaded = true;

          let projFIleID = 0;
          let refId = 0;
          let fileArray: string = "";
          let stNos: string = "";

          if (this.selectedFile == null) {
            this.selectedFile = new ProjectFilesVm();
          }

          if (this.selectedFile != null
            && this.selectedFile != undefined
          ) {
            projFIleID = this.selectedFile!.projectFileID!;
            refId = this.selectedFile!.refID! | 0;
            fileArray = await this.readFileAsBase64(file);

            stNos = this.getStoreNumbers(fileArray);
          }

          this.selectedFile = {
            projectFileID: projFIleID,
            fileName: file.name,
            purpose: this.purpose,
            type: this.refType,
            refID: refId,
            createdBy: this.storageService.getItem<any>('UserInfo').userID,
            filePath: file.name,
            createdDate: new Date(),
            fileIndex: -1,
            fileChanged: true,
            base64Bytes: fileArray,
            rowsTotalCount: parseInt(this.totalCount),
            storeNumbers: stNos
          }

          this.emitValueChanged.emit({ purpose: this.purpose, selFile: this.selectedFile });
          resolve(true); 

        } else {
          resolve(false);
          this.onDelete();
          this.toastr.error("Not a valid " + this.purpose + " file. Please try again.");
        }
      };
      reader.onerror = () => reject(false);
      reader.readAsArrayBuffer(file);
    });
  }

  getHeaders(worksheet: XLSX.WorkSheet): string[] {
    const headers: string[] = [];
    const range = XLSX.utils.decode_range(worksheet['!ref'] || '');
    const startCol = range.s.c;
    const endCol = range.e.c;
    const startRow = range.s.r;

    for (let C = startCol; C <= endCol; C++) {
      const cell = worksheet[XLSX.utils.encode_cell({ c: C, r: startRow })];
      if (cell && cell.t) headers.push(XLSX.utils.format_cell(cell));
    }
    return headers;
  }

  getRowCount(worksheet: XLSX.WorkSheet): number {
    // const range = XLSX.utils.decode_range(worksheet['!ref'] || '');
    // return range.e.r - range.s.r + 1; // Number of rows

    const data1 = XLSX.utils.sheet_to_json(worksheet, { header: 1 });
    let rowCount = this.countNonEmptyRows(data1);

    return rowCount;
  }

  countNonEmptyRows(data: any[]): number {
    let result = data.filter(row => {
      // Filter out rows that are entirely empty
      return row.some((cell: string | null | undefined) => cell !== null && cell !== undefined && cell !== '');
    });
    
    //console.log('Store file contnt', data, result);

    return result.length;
  }

// Function to convert Base64 string to binary using Array.from and map
base64ToUint8Array(base64: any) {
  const binaryString = window.atob(base64); // Decode base64 to binary string
  return new Uint8Array(Array.from(binaryString, char => char.charCodeAt(0)));
}

getStoreNumbers(base64String: any): any {
  const binaryData = this.base64ToUint8Array(base64String);
  const workbook = XLSX.read(binaryData, { type: 'array' });
  const worksheet = workbook.Sheets[workbook.SheetNames[0]];

  const data1 = XLSX.utils.sheet_to_json(worksheet, { header: 1 });

  let result = data1.filter((row: any) => {
    // Filter out rows that are entirely empty
    return row.some((cell: string | null | undefined) => cell !== null && cell !== undefined && cell !== '');
  });
  
  const storeIds = result.slice(1).map((store: any) => store[2]).join(',');

  //console.log('Store file contnt', result, storeIds);

  return storeIds;
}

  readExcelFile(file: UFile): Promise<{ headers: string[], rowCount: number }> {
    return new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.onload = (e: any) => {
        const data = new Uint8Array(e.target.result);
        const workbook = XLSX.read(data, { type: 'array' });
        const worksheet = workbook.Sheets[workbook.SheetNames[0]];
        const headers = this.getHeaders(worksheet);
        const rowCount = this.getRowCount(worksheet);
        resolve({ headers, rowCount });
      };
      reader.onerror = () => reject(new Error('Failed to read the file'));
      reader.readAsArrayBuffer(file);
    });
  }

  isFileContainsValidColumns(headers: any[], columns: any[]): boolean {
    return headers.every(header => columns.includes(header));
  }

  onDelete(): void {
    if (!this.disableAfterReview) {
      this.clearFileDetails();

      this.emitValueChanged.emit({ purpose: this.purpose, selFile: this.selectedFile });
    }
  }

  clearFileDetails() {
    this.selectedFile = null;
    this.fileName = '';
    this.totalCount = "";
    this.displayTotalCount = "";
    this.isFileUploaded = false;

    if (this.fileInput) {
      this.fileInput.nativeElement.value = '';
    }
  }
}
